import { FacebookFilled, InstagramOutlined } from '@ant-design/icons';
import { Col, Flex, Row } from 'antd';
import { DesignProps } from 'api/DesignApi';
import imageLogoVerticalWhite from 'assets/logo-vertical-white.svg';
import { useCompanyContext } from 'contexts/CompanyContext';
import { NavLink } from 'react-router-dom';
import { ensureHttp } from 'utils/utils';
import './PublicFooter.css';

export const FACEBOOK_URL = 'https://www.facebook.com/EternalApplications/';
export const INSTAGRAM_URL = 'https://www.instagram.com/eternalapplicationsinc/';

function PublicFooter({ designProps, isCompact = false }: { designProps?: DesignProps; isCompact?: boolean }) {
  const { companyConfig } = useCompanyContext();

  const donationUrl = ensureHttp(designProps?.donationUrl);
  const volunteerUrl = ensureHttp(designProps?.volunteerUrl);
  const privacyUrl = ensureHttp(designProps?.privacyUrl) || companyConfig.privacyUrl;
  const termsUrl = ensureHttp(designProps?.termsUrl) || companyConfig.termsUrl;
  const contactEmail = designProps?.email || companyConfig.contactEmail;

  if (isCompact) {
    return (
      <footer className="public-footer public-footer-compact">
        <Flex className="menu-container" gap={10} justify="center" align="center" wrap>
          <a href={privacyUrl} target="_blank" rel="noopener noreferrer">
            Privacy
          </a>
          <div className="separator" />
          <a href={termsUrl} target="_blank" rel="noopener noreferrer">
            Terms
          </a>
          <div className="separator" />
          <a href={`mailto:${contactEmail}`}>Contact</a>
        </Flex>
      </footer>
    );
  }

  return (
    <footer className="public-footer" style={{ backgroundColor: designProps?.colorPrimary || undefined }}>
      <Row align="middle" wrap={false} className="public-footer-container">
        {designProps?.companyName ? (
          <>
            <Col flex="100%">
              <Flex justify="center" className="branded-footer-title">
                {designProps.footerText || companyConfig.footerText}
              </Flex>
              <Flex className="menu-container" gap={10} justify="center" align="center">
                <a href={privacyUrl} target="_blank" rel="noopener noreferrer">
                  Privacy
                </a>
                <div className="separator" />
                <a href={termsUrl} target="_blank" rel="noopener noreferrer">
                  Terms
                </a>
                <div className="separator" />
                <a href={`mailto:${contactEmail}`}>Contact</a>
                {donationUrl && (
                  <>
                    <div className="separator" />
                    <a href={donationUrl} target="_blank" rel="noopener noreferrer">
                      Donate
                    </a>
                  </>
                )}
                {volunteerUrl && (
                  <>
                    <div className="separator" />
                    <a href={volunteerUrl} target="_blank" rel="noopener noreferrer">
                      Volunteer
                    </a>
                  </>
                )}
              </Flex>
            </Col>
          </>
        ) : (
          <>
            <Col flex="25%">
              <NavLink to="/" className="logo-container">
                <img src={imageLogoVerticalWhite} alt="" className="logo" />
              </NavLink>
            </Col>

            <Col flex="50%">
              <Flex className="menu-container" gap={10} justify="center" align="center">
                <a href={companyConfig.privacyUrl} target="_blank" rel="noopener noreferrer">
                  Privacy
                </a>
                <div className="separator" />
                <a href={companyConfig.termsUrl} target="_blank" rel="noopener noreferrer">
                  Terms
                </a>
              </Flex>
            </Col>

            <Col flex="25%">
              <Flex justify="end" gap={10}>
                <a href={INSTAGRAM_URL} target="_blank" rel="noopener noreferrer">
                  <InstagramOutlined style={{ fontSize: '32px', color: '#fff' }} />
                </a>

                <a href={FACEBOOK_URL} target="_blank" rel="noopener noreferrer">
                  <FacebookFilled style={{ fontSize: '32px', color: '#fff' }} />
                </a>
              </Flex>
            </Col>
          </>
        )}
      </Row>
    </footer>
  );
}

export default PublicFooter;
